import { css } from 'styled-components';
import { Theme } from '@cubeyou-team/hx-theme';
import { StyledItemActions } from './components';

export const getIsDragging = (props: {
  isDragging?: boolean;
  theme: Theme;
}) => {
  if (!props.isDragging) {
    return false;
  }

  return css`
    border-left: 3px solid ${props => props.theme.colors.secondary};
  `;
};
export const getItemInteractionStyle = (props: {
  isDraggable?: boolean;
  disabled?: boolean;
  theme: Theme;
}) => {
  if (props.disabled) {
    return css`
      &:hover,
      &:focus,
      &:active {
        background-color: transparent;
      }
    `;
  }

  if (!props.isDraggable) {
    return css`
      &:hover,
      &:focus,
      &:active {
        background-color: ${props.theme.colors.light};

        ${StyledItemActions} {
          display: flex;
        }
      }
    `;
  }

  return css`
    &:hover {
      background-color: ${props.theme.colors.light};

      ${StyledItemActions} {
        display: flex;
      }
    }
  `;
};
